import { eDonHangChiTietActionTypeDefine } from "../../action-types/don-hang/IDonHangChiTietActions";
import { generateActions } from "../generateActions";

export const donHangChiTietAction = {
    ...generateActions(eDonHangChiTietActionTypeDefine, "DON_HANG_CHI_TIET"),
}
